import { SERVICE_NAME } from 'config';


const bootstrapClient = bootstrapFn => ({ detail }) => {
  if (!detail || !detail.application) {
    return;
  }

  const attributes = [
    ['data-application-name', SERVICE_NAME],
    ['data-application-uuid', detail.application.uuid],
    ['data-application-initialized', 'false']
  ]
    .map(([key, value]) => [key, `"${value}"`])
    .map(options => options.join('='))
    .map(attribute => `[${attribute}]`);

  const node = document.querySelector(attributes.join(''));
  if (!node) {
    return;
  }

  const event = new CustomEvent('application::initialized', {
    detail
  });
  document.dispatchEvent(event);

  node.removeAttribute('data-application-initialized');

  bootstrapFn({ node, detail });
};

const applicationEmitter = () => (uuid) => {
  const event = new CustomEvent('application::ready', {
    detail: {
      application: {
        uuid
      }
    }
  });

  const time = 10;
  const interval = setInterval(() => document.dispatchEvent(event), time);
  document.addEventListener('application::initialized', ({ detail }) => {
    if (!detail || !detail.application) {
      return;
    }
    const { application } = detail;
    if (application.uuid === uuid) {
      clearInterval(interval);
    }
  });
};

export { bootstrapClient, applicationEmitter };
